import type { ReactNode } from 'react';
import { cn } from './cn.js';

export interface StatCardProps {
  label: ReactNode;
  value: ReactNode;
  delta?: { value: string; positive?: boolean };
  hint?: ReactNode;
  icon?: ReactNode;
  className?: string;
  accent?: boolean;
}

export function StatCard({
  label,
  value,
  delta,
  hint,
  icon,
  className,
  accent,
}: StatCardProps) {
  return (
    <div
      className={cn(
        'rounded-2xl border p-5',
        accent
          ? 'border-gold/25 bg-gradient-to-br from-gold/10 via-surface-2 to-surface-2'
          : 'border-line bg-surface-2',
        className,
      )}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="text-[11px] uppercase tracking-wider text-text-muted font-medium">
          {label}
        </div>
        {icon && <div className="text-gold/80">{icon}</div>}
      </div>
      <div
        className={cn(
          'mt-3 text-3xl font-semibold tracking-tight',
          accent ? 'text-gold-light' : 'text-text',
        )}
      >
        {value}
      </div>
      {(delta || hint) && (
        <div className="mt-2 flex items-center gap-2 text-xs">
          {delta && (
            <span
              className={cn(
                'font-medium',
                delta.positive ? 'text-success' : 'text-danger',
              )}
            >
              {delta.positive ? '▲' : '▼'} {delta.value}
            </span>
          )}
          {hint && <span className="text-text-muted">{hint}</span>}
        </div>
      )}
    </div>
  );
}
